import { useEffect, useState } from "react";
import blogApi from "../utils/api/blogApi";
import { useNavigate } from "react-router-dom";
import { BlogResponseDto, LocalizationEnum } from "../utils/types/blog";
import blog from "../images/Blog.png";

const BlogSection = () => {
  const [blogs, setBlogs] = useState<BlogResponseDto[]>([]);
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [selectedLang, setSelectedLang] = useState<LocalizationEnum>(LocalizationEnum.MK);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true)
    const loadBlogs = async () => {
      try {
        const { data } = await blogApi.get(`/blogs?page=${page}&pageSize=2&lang=${selectedLang}`);

        setBlogs(data.items);
      } catch (err) {
        console.error(err);
      }
      finally{
        setLoading(false)
      }
    };
    loadBlogs();
  }, [page, selectedLang]);


  const goToBlog = (id: number) => {
    navigate(`/blog/${id}`);
  };

  const stripHtml = (html:any) => {
    if (!html) return "";

    // Create a temporary DOM element
    const temp = document.createElement("div");
    temp.innerHTML = html;

    // Remove all script and style tags
    const scripts = temp.querySelectorAll("script, style");
    scripts.forEach((tag) => tag.remove());

    // Extract text content
    let text = temp.textContent || temp.innerText || "";

    // Clean extra whitespace
    return text.replace(/\s+/g, " ").trim();
  }

  if(loading)
    return (
       <div className="p-6 flex justify-center">
          <h1>Loading blogs...</h1>
       </div>
    )
 
 return (
 <div className="bg-white w-full">
      <section className="text-center pt-24 px-4 md:px-6">
        <div className="container mx-auto">
          <div className="text-left md:text-center mb-12">
            <div className="flex items-center md:justify-center gap-2 mb-6">
              <div className="w-6 h-6 flex items-center justify-center rounded-full">
                <img src={blog} alt="" className="w-6 h-6" />
              </div>
              <span className="font-semibold text-sm">БЛОГ</span>
            </div>

            <h2 className="text-3xl md:text-5xl font-semibold mb-6">
              Следете како се развива Merakzy
            </h2>

            <p className="text-lg md:text-xl text-gray-800">
              Ви ги споделуваме сите нови функционалности на Merakzy со упатства и совети за <br />
              пофективно и поефикасно работење.
            </p>
          </div>
        </div>
      </section>

      {/* BlogSection */}
       <section className="bg-white pb-24 mt-20 px-4 md:px-6">
        <div className="container mx-auto space-y-20">

          {blogs.map((blog) => (
            <div
              key={blog.id}
              className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center"
            >
              <div className="xl:h-full">
                {blog.mainImageUrl && (
                  <img
                    src={blog.mainImageUrl}
                    alt={blog.title}
                    className="w-full h-full object-cover rounded-3xl shadow"
                  />
                )}
              </div>

              <div>
                <h2 className="sm:text-2xl xl:text-3xl font-bold mb-4 text-[#0c0407]">
                  {blog.title}
                </h2>

                <p className="text-gray-700 text-lg mb-6 line-clamp-5 md:line-clamp-1 lg:line-clamp-4 xl:line-clamp-6">
                  {stripHtml(blog.content)}
                </p>

                <button
                  onClick={() => goToBlog(blog.id)}
                  className="bg-[#fa0053] text-white px-8 py-3 hover:opacity-90 transition"
                  style={ {borderRadius: "16px"}}
                >
                  Повеќе
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default BlogSection;